import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IEmployerSearchRequest } from 'src/app/modules/shared/models/operation.model';
import { environment } from 'src/environments/environment';
import {
  IPoliciesResponse,
  ISubjectRequest,
  ISubjectResponse,
} from '../../modules/shared/models/policy.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private readonly _http: HttpClient) {}

  get isLocalEnv(): boolean {
    return environment.name === 'LOCAL' || environment.name === 'LOCAL_BE';
  }

  getPoliciesByNdg(
    ndg: string,
    policyNumber: string,
    contractNumber: string
  ): Observable<IPoliciesResponse> {
    const url = environment.apiBaseUrl + environment.apiPaths.policies;
    let qs = `?ndg=${ndg}`;
    if (policyNumber) {
      qs += `&policyNumber=${policyNumber}`;
    }
    if (contractNumber) {
      qs += `&contractNumber=${contractNumber}`;
    }
    return this._http.get<IPoliciesResponse>(url + qs);
  }

  getSubject(body: ISubjectRequest): Observable<ISubjectResponse> {
    const url = environment.apiBaseUrl + environment.apiPaths.subjects;
    if (this.isLocalEnv) {
      return this._http.get<ISubjectResponse>(url);
    }
    return this._http.post<ISubjectResponse>(url, body);
  }

  getEmployer(body: IEmployerSearchRequest) {
    const url = environment.apiBaseUrl + environment.apiPaths.intesa.employer;

    const filteredParams = Object.entries(body).filter(
      ([_, value]) => value !== null && value !== undefined && value !== ''
    );
    const filteredObject = filteredParams.reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {} as Record<string, any>);

    const params = new HttpParams({ fromObject: filteredObject });

    if (this.isLocalEnv) {
      return this._http.get<any>(url);
    }

    return this._http.get<any>(url, { params });
  }

  getAnagrafica(fiscalCode: string) {
    const url = environment.apiBaseUrl + environment.apiPaths.getAnagrafica;
    const qs = `?fiscalCode=${fiscalCode}`;
    if (this.isLocalEnv) {
      return this._http.get<any>(url);
    }
    return this._http.get<any>(url + qs);
  }
}
